/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import {EMOJIS_PER_ROW} from '@app/components/channel/emoji_picker/EmojiPickerConstants';
import {STICKERS_PER_ROW} from '@app/components/channel/sticker_picker/StickerPickerConstants';

const MOBILE_LIST_INLINE_PADDING = 8;
const MOBILE_EMOJI_TARGET_CELL_WIDTH = 42;
const MOBILE_STICKER_MAX_CELL_WIDTH = 88;
const MOBILE_STICKER_GAP = 8;

function getAvailableGridWidth(containerWidth: number): number {
	if (containerWidth <= 0) {
		return 0;
	}

	return Math.max(0, containerWidth - MOBILE_LIST_INLINE_PADDING);
}

export function getMobileEmojiGridColumns(containerWidth: number): number {
	const availableGridWidth = getAvailableGridWidth(containerWidth);

	if (availableGridWidth === 0) {
		return EMOJIS_PER_ROW - 1;
	}

	return Math.max(1, Math.min(EMOJIS_PER_ROW, Math.ceil(availableGridWidth / MOBILE_EMOJI_TARGET_CELL_WIDTH)));
}

export function getMobileStickerGridColumns(containerWidth: number): number {
	const availableGridWidth = getAvailableGridWidth(containerWidth);

	if (availableGridWidth === 0) {
		return STICKERS_PER_ROW;
	}

	return Math.max(
		1,
		Math.floor((availableGridWidth + MOBILE_STICKER_GAP) / (MOBILE_STICKER_MAX_CELL_WIDTH + MOBILE_STICKER_GAP)),
	);
}
